if (!customElements.get('pdp-floating-video')) {
  class PdpFloatingVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.closeBtn = this.querySelector('[data-close]');
      this.muteBtn = this.querySelector('[data-mute]');
      this.container = this.querySelector('[data-video-container]');
      this.modal = this.querySelector('[data-video-modal]');
      this.modalVideo = this.modal ? this.modal.querySelector('video') : null;
      this.modalCloseBtn = this.modal ? this.modal.querySelector('[data-modal-close]') : null;
      this.modalMuteBtn = this.modal ? this.modal.querySelector('[data-modal-mute]') : null;
      this.productId = this.dataset.productId;
    }

    connectedCallback() {
      if (!this.video) return;

      if (sessionStorage.getItem(`pdp-video-dismissed-${this.productId}`)) {
        this.hidden = true;
        return;
      }

      this.closeBtn.addEventListener('click', (e) => { e.stopPropagation(); this.close(); });
      this.muteBtn.addEventListener('click', (e) => { e.stopPropagation(); this.toggleMute(this.video, this.muteBtn); });
      this.container.addEventListener('click', () => this.openModal());

      if (this.modalCloseBtn) {
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
      }
      if (this.modalMuteBtn) {
        this.modalMuteBtn.addEventListener('click', () => this.toggleMute(this.modalVideo, this.modalMuteBtn));
      }
      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) this.closeModal();
        });
      }

      this.updateMuteIcon(this.video, this.muteBtn);
    }

    close() {
      this.hidden = true;
      this.video.pause();
      sessionStorage.setItem(`pdp-video-dismissed-${this.productId}`, 'true');
    }

    openModal() {
      if (!this.modal || !this.modalVideo) return;
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      this.modalVideo.currentTime = this.video.currentTime;
      this.modalVideo.muted = this.video.muted;
      this.modalVideo.play();
      this.video.pause();
      this.updateMuteIcon(this.modalVideo, this.modalMuteBtn);

      document.addEventListener('keydown', this.escHandler = (e) => {
        if (e.key === 'Escape') this.closeModal();
      });
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.body.style.overflow = '';
      this.modalVideo.pause();
      this.video.currentTime = this.modalVideo.currentTime;
      this.video.muted = this.modalVideo.muted;
      this.video.play();
      this.updateMuteIcon(this.video, this.muteBtn);

      if (this.escHandler) {
        document.removeEventListener('keydown', this.escHandler);
      }
    }

    toggleMute(videoEl, btnEl) {
      videoEl.muted = !videoEl.muted;
      this.updateMuteIcon(videoEl, btnEl);
    }

    updateMuteIcon(videoEl, btnEl) {
      if (!btnEl) return;
      const mutedIcon = btnEl.querySelector('[data-icon-muted]');
      const unmutedIcon = btnEl.querySelector('[data-icon-unmuted]');
      if (!mutedIcon || !unmutedIcon) return;

      mutedIcon.style.display = videoEl.muted ? 'block' : 'none';
      unmutedIcon.style.display = videoEl.muted ? 'none' : 'block';
    }
  }

  customElements.define('pdp-floating-video', PdpFloatingVideo);
}
